// shared/hooks/use-bus.ts — Platik-IA
// Suscripción tipada al bus con auto-limpieza cuando el elemento se desmonta.

import { bus }        from '../../core/event-bus';
import type { AppEvents } from '../../core/event-bus';

type EventKey = keyof AppEvents;
type Handler<K extends EventKey> = (payload: AppEvents[K]) => void;

/**
 * Suscribe a un evento del bus y cancela automáticamente
 * cuando el elemento host sale del DOM.
 */
export function useBus<K extends EventKey>(
  event:   K,
  handler: Handler<K>,
  host:    HTMLElement
): () => void {
  bus.on(event, handler as never);

  const cleanup = () => bus.off(event, handler as never);

  // MutationObserver detecta cuando el host es removido del DOM
  const observer = new MutationObserver(() => {
    if (!document.contains(host)) {
      cleanup();
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  return cleanup;
}
